import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '@/views/Mypage.vue'

const routes = [
  {
    // 1. 로그인 페이지
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "user" */ '../views/Login.vue')
  },
  {
    // 1-1. 회원가입 페이지
    path: '/join',
    name: 'Join',
    component: () => import(/* webpackChunkName: "user" */ '../views/Join.vue')
  },
  {
    // 2-1. 마이페이지(메인)
    path: '/',
    name: 'Mypage',
    // component: () => import(/* webpackChunkName: "user" */ '../views/Mypage.vue')
    component: HomeView
  },
  {
    // 2-2. 정보수정 페이지(헤더)
    path: '/myinfo',
    name: 'MyInfo',
    component: () => import(/* webpackChunkName: "user" */ '../views/Myinfo.vue')
  },

  {
    // 맵: 목록
    path: '/map',
    name: 'Map',
    component: () => import(/* webpackChunkName: "poi" */ '../views/Map.vue')
  },
  {
    // 몬스터: 뷰
    path: '/monster/view/:monster_no',
    name: 'MonsterView',
    component: () => import(/* webpackChunkName: "poi" */ '../views/MonsterView.vue')
  },

  {
    // 아이템: 리스트
    path: '/item/:target_item?',
    name: 'Item',
    component: () => import(/* webpackChunkName: "poi" */ '../views/Item.vue')
  },
  {
    // 아이템: 뷰
    path: '/item/view/:item_no',
    name: 'ItemView',
    component: () => import(/* webpackChunkName: "poi" */ '../views/ItemView.vue')
  },
  {
    // 펫: 리스트
    path: '/pet',
    name: 'Pet',
    component: () => import(/* webpackChunkName: "poi" */ '../views/Pet.vue')
  },
  {
    // 개선내역: 리스트
    path: '/notice',
    name: 'Notice',
    component: () => import(/* webpackChunkName: "poi" */ '../views/Notice.vue')
  },
  {
    // 클래스: 리스트
    path: '/class',
    name: 'Class',
    component: () => import(/* webpackChunkName: "poi" */ '../views/Class.vue')
  },
  {
    // 클래스: 리스트2
    path: '/class2',
    name: 'Class2',
    component: () => import(/* webpackChunkName: "poi" */ '../views/Class2.vue')
  },
  {
    // 클래스: 뷰
    path: '/class/view/:class_no',
    name: 'ClassView',
    component: () => import(/* webpackChunkName: "poi" */ '../views/ClassView.vue')
  },
  {
    // 제보&건의: 리스트
    path: '/report',
    name: 'Report',
    component: () => import(/* webpackChunkName: "poi" */ '../views/Report.vue')
  },
  {
    // 제보&건의: 뷰
    path: '/report/view/:report_no',
    name: 'ReportView',
    component: () => import(/* webpackChunkName: "poi" */ '../views/ReportView.vue')
  },
  {
    // 조합 공유: 리스트
    path: '/mapdeck',
    name: 'Mapdeck',
    component: () => import(/* webpackChunkName: "poi" */ '../views/Mapdeck.vue')
  },
  {
    // 조합 공유: 뷰
    path: '/mapdeck/view/:md_no',
    name: 'MapdeckView',
    component: () => import(/* webpackChunkName: "poi" */ '../views/MapdeckView.vue')
  },
  {
    // 유용한 정보
    path: '/info',
    name: 'Info',
    component: () => import(/* webpackChunkName: "poi" */ '../views/Info.vue')
  },

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
